import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './../../styles/form.module.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import { isNull } from '../../helpers/utils';
import { validateCaptcha } from '../../helpers/helper';
import { forgotPasswordOptions, defaultValues } from './options';
import {
  AlertConfig,
  CAPTCHA,
  EMAIL,
  LOGIN,
  MESSAGE,
  NOT_VERIFIED,
  ON_CHANGE,
  REQUEST_FAILED,
  siteKey,
  TEMPLATE,
  VERIFICATION_SEND,
  VERIFY_EMAIL,
  VERIFY_LINK_EXPIRED
} from '../../content/constants';
import {
  Info,
  FormHeader,
  Logo,
  InputField,
  Button,
  AlertBox,
  NavigateLink
} from '../../components';
import { useQuery } from 'src/hooks/useQuery';
import { verifyEmailApi } from 'src/services/api';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../context/AuthContext';
const EmailVerification = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubmitting, setSubmitting] = useState(false);
  const { data } = useContext(AuthContext);
  const logoUrl = data.tenantDetail?.logo || null;
  
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
    setValue
  } = useForm({
    mode: ON_CHANGE
  });

  const alertRef = useRef();
  let query = useQuery();
  useEffect(() => {
    document.title = t('verify_email_page_title');
  });
  useEffect(() => {
    if (query.get(MESSAGE) === NOT_VERIFIED) {
      // User registered and trying to login without email verification
      alertRef.current.showAlert(AlertConfig[NOT_VERIFIED]);
    } else {
      // Email Verification link expired
      alertRef.current.showAlert(AlertConfig[VERIFY_LINK_EXPIRED]);
    }
  }, [query]);
  const onChangeCaptcha = (token) => {
    isNull(validateCaptcha(token))
      ? clearErrors(CAPTCHA)
      : setError(CAPTCHA, ...validateCaptcha(token));
    setValue(CAPTCHA, token);
  };

  const onSubmit = async (data) => {
    setSubmitting(true);
    verifyEmail(data);
  };
  const verifyEmail = (data) => {
    const email = query.get(EMAIL);
    const payload = {
      ...data,
      email
    };
    verifyEmailApi(payload)
      .then(() => {
        setEmail(email);
        alertRef.current.showAlert(AlertConfig[VERIFICATION_SEND]);
      })
      .catch(() => {
        alertRef.current.showAlert(AlertConfig[REQUEST_FAILED]);
      })
      .finally(() => {
        window.grecaptcha.reset();
        for (const key in defaultValues) {
          setValue(key, defaultValues[key]);
        }
        setSubmitting(false);
      });
  };

  const navigateToLogin = () => {
    return `/${LOGIN}${window.location.search.replace(
      `${TEMPLATE}=${VERIFY_EMAIL}`,
      ''
    )}`;
  };
  return (
    <div className={`${styles.auth_wrapper} ${
      logoUrl ? styles.auth_align_center : ''
    }`}>
      <div className={styles.logo}>
        <Logo logoUrl={logoUrl} />
      </div>
      {!logoUrl ? <Info logoUrl={logoUrl} /> : <div></div>}
      <div className={styles.form_container}>
        <AlertBox ref={alertRef} email={email} />
        <form onSubmit={handleSubmit(onSubmit)} className={styles.w_90}>
          <div className={styles.form_content}>
            <FormHeader
              heading={t('resend_email_verification_header')}
              subHeading={t('resend_email_verification_sub_header')}
            />
            <InputField
              label={t('email')}
              placeholder={t('enter_email_address')}
              type="email"
              id="email"
              value={query.get(EMAIL)}
              disabled
              data-testid="email-verification-email-address-input-field"
            />
            <ReCAPTCHA
              className={styles.captha}
              sitekey={siteKey}
              {...register('captcha', forgotPasswordOptions.captcha)}
              onChange={onChangeCaptcha}
              data-testid="email-verification-recaptcha"
            />
            <span className={styles.err_text}>{errors?.captcha?.message}</span>

            <Button
              showSpinner={isSubmitting}
              label={t('send')}
              type="submit"
              data-testid="email-verification-submit-button"
            />
            <div className={styles.navigator}>
              <NavigateLink
                linkText={t('return_to_log_in')}
                linkUrl={navigateToLogin()}
                data-testid="email-verification-login-link"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailVerification;
